import styled, { keyframes } from 'styled-components';

const leftMove = keyframes`
  0% {
    opacity: 0;
    transform : translateX(200px);
  }
  100% {
    opacity: 1;
    transform : translateX(0px);
  }
`;

const growing = keyframes`
  0% {
    opacity: 0;
    flex: 0;
    transform : translateX(200px);
  }
  100% {
    opacity: 1;
    flex: 1;
    transform : translateX(0px);
  }
`;

const tableCols = {
    name: {
        width: '13%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#3A3A3A',
    },
    warning: {
        width: '4%',
        color: '#3A3A3A',
    },
    description: {
        width: '7%',
        color: '#3A3A3A',
    },
    requestType: {
        width: '9%',
        color: '#3A3A3A',
    },
    approvalProcess: {
        width: '9%',
        color: '#3A3A3A',
    },
    submissionPeriod: {
        color: '#3A3A3A',
        width: '16%',
    },
    requestPeriod: {
        width: '16%',
        color: '#3A3A3A',
    },
    hyperFindQuery: {
        width: '10%',
        clear: 'both',
        display: 'inline-block',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3A3A3A',
    },
    type: {
        width: '14%',
        color: '#3A3A3A',
    },
    buttonSection: {
        position: 'absolute',
        right: '0',
        backgroundColor: '#f7f9fc',
        borderLeft: '1px solid lightgray',
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        flex: '1 20 100%',
        paddingLeft: '5px',
        paddingRight: '5px',
    },
    adjustment: {
        top: '10px'
    },
    setup: {
        width: '14%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#3A3A3A',
    }
};

export const styles = theme => ({
    green: {
        color: 'green',
    },
    red: {
        color: 'red',
    },
    darkorange: {
        color: 'darkorange',
    },
    fontAwesomeIcon: {
        margin: '7px'
    },
    buttonsAction: {
        textTransform: 'initial',
        color: '#767676',
        padding: '0px'
    },
    namefontWeigth: {
        fontWeight: 600
    },
    quotaItemStyling: {
        height: '50px',
        margin: 0,
        width: '100%',
        '&:hover': {
            backgroundColor: '#f7f9fc'
        }
    },
    ...tableCols,
});

export const RowItem = styled.div`
  overflow: hidden;
  cursor: pointer;
  background-color: white;
  position: relative;
  align-items: center;
  display: flex;
  animation: ${leftMove} ${props => 200 + (props.index * 40)}ms linear;
  border-radius: 5px;
  padding: 0;
`;

export const ItemTitle = styled.div`
  padding: 0 5px;
  flex: 0 0 auto;
`;

export const Buttons = styled.div`
  position: relatice;
  display: flex;
  animation: ${growing} 200ms linear;
`;